export enum StatusBrief {
  COMPLETE = 'COMPLETE',
  PROGRESS = 'PROGRESS',
}
